module.exports = __webpack_public_path__ + "img/Hybrid.bd548f52.svg";